<template>
  <b-nav-item-dropdown text="About" >
    <b-dropdown-item @click="goTo({name: 'announcements' })">Announcements</b-dropdown-item>
    <b-dropdown-item @click="goTo({ name: 'history' })">History</b-dropdown-item>
    <b-dropdown-item @click="goTo({ name: 'aimsAndScope' })">Aims & Scope</b-dropdown-item>
    <b-dropdown-item @click="goTo({ name: 'employees' })">Employees</b-dropdown-item>
    <b-dropdown-item @click="goTo({ name: 'ethicsAndMalpractice' })" class="hidden-sm-up">Ethics & Malpractice</b-dropdown-item>
    <b-dropdown-item @click="goTo({ name: 'careers' })">Careers</b-dropdown-item>
    <b-dropdown-item @click="goTo({ name: 'contact' })">Contact</b-dropdown-item>
    <b-dropdown-item @click="goTo({ name: 'sponsorshipRequest' })">Sponsorship Request</b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
  export default {
    name: 'about-dropdown',
    methods: {
      goTo (rO) {
        this.$router.push(rO)
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// AboutDropdownComponent.vue?019baf47